<template>
  <div class="car-container" :id="categoryName">
    <div class="car-inner">
      <div class="car-section-header">
        <div class="catIcoBox" v-html="catNameToIco"></div>
        <h2>{{ categoryName }}</h2>
      </div>
      <div class="car-header">
        <h2>Materiały video</h2>
        <div class="car-dots">
          <ul>
            <li
              v-for="(video, index) in videos"
              :key="categoryName + index"
              :class="{ active: index == currentPointer }"
              @click.prevent="goToSlideNo(index)"
            ></li>
          </ul>
        </div>
      </div>

      <div class="carousel">
        <div
          class="carousel-navigation nav--left"
          @click.prevent="goToSlideNo(getDecreasedPointer(1))"
        >
          <a class="arrow-left"></a>
        </div>

        <div class="slide-main">
          <transition name="slide-fade" mode="out-in">
            <div
              :key="currentPointer"
              class="inner"
              :style="{
                background:
                  'url(' +
                  getThumbnailPath(videoId(getIncrementedPointer(0))) +
                  ')'
              }"
            >
              <div class="content">
                <a
                  :href="videoUrl(getIncrementedPointer(0))"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="24"
                    viewBox="0 0 16 24"
                  >
                    <path
                      class="a"
                      d="M141,147l16-12-16-12Z"
                      transform="translate(-141 -123)"
                    />
                  </svg>
                  Odtwórz
                </a>
                <h3 v-html="videoTitle(currentPointer)"></h3>
              </div>
            </div>
          </transition>
        </div>

        <div class="slide-small slide-small--first">
          <transition name="slide-fade" mode="out-in">
            <div :key="currentPointer">
              <div
                class="video"
                :style="{
                  background:
                    'url(' +
                    getThumbnailPath(videoId(getIncrementedPointer(1))) +
                    ')'
                }"
              >
                <div class="content">
                  <img
                    v-if="videoIcoName(getIncrementedPointer(1)) != ''"
                    class="function-ico"
                    :src="getIconPath(videoIcoName(getIncrementedPointer(1)))"
                    alt=""
                  />
                  <a
                    :href="videoUrl(getIncrementedPointer(1))"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="24"
                      viewBox="0 0 16 24"
                    >
                      <path
                        class="a"
                        d="M141,147l16-12-16-12Z"
                        transform="translate(-141 -123)"
                      />
                    </svg>
                    Odtwórz
                  </a>
                </div>
              </div>
              <h3 v-html="videoTitle(getIncrementedPointer(1))"></h3>
            </div>
          </transition>
        </div>

        <div class="slide-small slide-small--second">
          <transition name="slide-fade" mode="out-in">
            <div :key="currentPointer">
              <div
                class="video"
                :style="{
                  background:
                    'url(' +
                    getThumbnailPath(videoId(getIncrementedPointer(2))) +
                    ')'
                }"
              >
                <div class="content">
                  <img
                    v-if="videoIcoName(getIncrementedPointer(2)) != ''"
                    class="function-ico"
                    :src="getIconPath(videoIcoName(getIncrementedPointer(2)))"
                    alt=""
                  />
                  <a
                    :href="videoUrl(getIncrementedPointer(2))"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="24"
                      viewBox="0 0 16 24"
                    >
                      <path
                        class="a"
                        d="M141,147l16-12-16-12Z"
                        transform="translate(-141 -123)"
                      />
                    </svg>
                    Odtwórz
                  </a>
                </div>
              </div>
              <h3 v-html="videoTitle(getIncrementedPointer(2))"></h3>
            </div>
          </transition>
        </div>

        <div
          class="carousel-navigation nav--right"
          @click.prevent="goToSlideNo(getIncrementedPointer(1))"
        >
          <a class="arrow-right"></a>
        </div>
      </div>
      <div v-if="articles.length > 0" class="car-header">
        <h2>Artykuły</h2>
      </div>

      <section v-if="articles.length > 0" class="gr-articles">
        <a
          class="gr-article"
          v-if="typeof articles[0] != 'undefined'"
          :href="articles[0].url"
        >
          <img :src="articles[0].img" alt="" />
          <h4>{{ categoryName }}</h4>
          <h3>{{ articles[0].title }}</h3>
          <p>{{ articles[0].excerpt }}</p>
        </a>
        <a
          class="gr-article"
          v-if="typeof articles[1] != 'undefined'"
          :href="articles[1].url"
        >
          <img :src="articles[1].img" alt="" />
          <h4>{{ categoryName }}</h4>
          <h3>{{ articles[1].title }}</h3>
          <p>{{ articles[1].excerpt }}</p>
        </a>
        <a
          class="gr-article"
          v-if="typeof articles[2] != 'undefined'"
          :href="articles[2].url"
        >
          <img :src="articles[2].img" alt="" />
          <h4>{{ categoryName }}</h4>
          <h3>{{ articles[2].title }}</h3>
          <p>{{ articles[2].excerpt }}</p>
        </a>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: ["videos", "articles", "categoryName"],
  data() {
    return {
      currentPointer: 0,
      isChanging: false
    };
  },
  computed: {
    catNameToIco: function() {
      switch (this.categoryName) {
        case "piekarniki":
          return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="51.199" height="50" viewBox="0 0 51.199 50"><defs><clipPath id="a"><rect class="a" width="51.199" height="50" transform="translate(-110.233 48.7)"/></clipPath></defs><g transform="translate(110.233 -48.7)"><g class="b"><path class="a" d="M-66.5,98.7h-36.273a7.412,7.412,0,0,1-7.463-7.344V56.044a7.413,7.413,0,0,1,7.463-7.344H-66.5a7.412,7.412,0,0,1,7.462,7.344V91.356A7.411,7.411,0,0,1-66.5,98.7Zm-36.273-48.006a5.417,5.417,0,0,0-5.469,5.35V91.356a5.417,5.417,0,0,0,5.469,5.35H-66.5a5.416,5.416,0,0,0,5.468-5.35V56.044a5.416,5.416,0,0,0-5.468-5.35Z"/></g><path class="a" d="M-65.537,92.482h-38.191V70.5h38.191Zm-36.489-1.7h34.787V72.2h-34.787Zm26.237-29.236H-94.081V54.662h18.292Zm-16.589-1.7h14.886V56.364H-92.378Z"/><path class="a" d="M-66.023,67.017h-37.35a1,1,0,0,1-1-1,1,1,0,0,1,1-1h37.35a1,1,0,0,1,1,1A1,1,0,0,1-66.023,67.017Z"/></g></svg>';
        case "płyty":
          return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="70.575" height="50" viewBox="0 0 70.575 50"><defs><clipPath id="a"><rect class="a" width="70.575" height="50" transform="translate(-128.588 48.7)"/></clipPath></defs><g transform="translate(128.588 -48.7)"><g class="b"><path class="a" d="M-74.916,74.91a9.351,9.351,0,0,0-9.338,9.342A9.351,9.351,0,0,0-74.916,93.6a9.353,9.353,0,0,0,9.338-9.343,9.353,9.353,0,0,0-9.338-9.342m0,20.575A11.243,11.243,0,0,1-86.148,84.252,11.243,11.243,0,0,1-74.916,73.019,11.244,11.244,0,0,1-63.683,84.252,11.244,11.244,0,0,1-74.916,95.485m-34.928-17.4a7.617,7.617,0,0,0-7.606,7.606,7.618,7.618,0,0,0,7.606,7.61,7.615,7.615,0,0,0,7.606-7.61,7.614,7.614,0,0,0-7.606-7.606m0,17.111a9.516,9.516,0,0,1-9.5-9.505,9.512,9.512,0,0,1,9.5-9.5,9.509,9.509,0,0,1,9.5,9.5,9.512,9.512,0,0,1-9.5,9.505m34.39-41.218a7.613,7.613,0,0,0-7.6,7.606,7.614,7.614,0,0,0,7.6,7.61,7.62,7.62,0,0,0,7.615-7.61,7.619,7.619,0,0,0-7.615-7.606m0,17.111a9.511,9.511,0,0,1-9.5-9.505,9.511,9.511,0,0,1,9.5-9.5,9.512,9.512,0,0,1,9.505,9.5,9.513,9.513,0,0,1-9.505,9.505m-34.6-17.152a9.346,9.346,0,0,0-9.338,9.338,9.349,9.349,0,0,0,9.338,9.342,9.353,9.353,0,0,0,9.338-9.342,9.349,9.349,0,0,0-9.338-9.338m0,20.575A11.247,11.247,0,0,1-121.289,63.27a11.244,11.244,0,0,1,11.233-11.233A11.243,11.243,0,0,1-98.828,63.27a11.247,11.247,0,0,1-11.228,11.237M-125.038,50.6a1.99,1.99,0,0,0-1.655,2.166V94.639a1.99,1.99,0,0,0,1.655,2.166h63.476a1.965,1.965,0,0,0,1.655-2.166V52.761A1.965,1.965,0,0,0-61.562,50.6Zm63.476,48.1h-63.476a3.836,3.836,0,0,1-3.55-4.061V52.761a3.836,3.836,0,0,1,3.55-4.061h63.476a3.836,3.836,0,0,1,3.55,4.061V94.639a3.836,3.836,0,0,1-3.55,4.061m-34.187-5.725h6.734V89.828h-6.734Zm8.628,1.9H-97.643V87.933h10.522Z"/></g></g></svg>';
        case "okapy":
          return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="46.567" height="50" viewBox="0 0 46.567 50"><defs><clipPath id="a"><rect class="a" width="46.567" height="50" transform="translate(-88.584 48.7)"/></clipPath></defs><g transform="translate(88.584 -48.7)"><g class="b"><path class="a" d="M-56.371,98.347c.7-1.492.156-2.627-.425-3.829-.1-.2-.195-.407-.293-.62-.348-.767-.135-1.336.874-2.345a.613.613,0,0,0,0-.872.619.619,0,0,0-.871,0c-1,1-1.84,2.151-1.124,3.724.1.227.2.443.306.65.587,1.219.853,1.848.422,2.764a.613.613,0,0,0,.294.821.621.621,0,0,0,.26.06.614.614,0,0,0,.557-.353m-8.042,0c.7-1.492.152-2.627-.429-3.829q-.144-.3-.293-.62c-.348-.767-.135-1.336.871-2.345a.613.613,0,0,0,0-.872.615.615,0,0,0-.868,0c-1.007,1.007-1.836,2.154-1.124,3.724.1.227.2.443.306.65.59,1.219.854,1.848.422,2.764a.614.614,0,0,0,.294.821.627.627,0,0,0,.263.06.619.619,0,0,0,.558-.353m-8.268,0c.7-1.492.153-2.63-.428-3.835-.1-.2-.195-.4-.294-.617-.35-.764-.137-1.336.872-2.342a.613.613,0,0,0,0-.872.616.616,0,0,0-.869,0c-1.009,1.007-1.839,2.151-1.123,3.724.1.227.2.44.306.644.59,1.225.856,1.854.422,2.77a.614.614,0,0,0,.293.821.638.638,0,0,0,.264.06.621.621,0,0,0,.557-.353M-86.834,87.233h43.068V81.605H-86.834Zm44.818,1.747H-88.584V79.853h46.568Zm-28.969-9.124h10.136V50.449H-70.985ZM-59.1,81.605H-72.735V48.7H-59.1Z"/></g></g></svg>';
        case "zmywarki":
          return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="41.41" height="50" viewBox="0 0 41.41 50"><defs><clipPath id="a"><rect class="a" width="41.41" height="50" transform="translate(200.662 48.7)"/></clipPath></defs><g transform="translate(-200.662 -48.7)"><g class="b"><path class="a" d="M207.3,50.444a4.9,4.9,0,0,0-4.894,4.894v36.72a4.9,4.9,0,0,0,4.894,4.9h28.134a4.9,4.9,0,0,0,4.891-4.9V55.338a4.9,4.9,0,0,0-4.891-4.894ZM235.436,98.7H207.3a6.65,6.65,0,0,1-6.641-6.642V55.338A6.647,6.647,0,0,1,207.3,48.7h28.134a6.642,6.642,0,0,1,6.635,6.638v36.72a6.645,6.645,0,0,1-6.635,6.642"/><path class="a" d="M203.308,59.76h-.821a.872.872,0,0,1,0-1.744h.821a.872.872,0,0,1,0,1.744"/><path class="a" d="M241.2,59.76H201.534a.872.872,0,0,1,0-1.744H241.2a.872.872,0,1,1,0,1.744"/><path class="a" d="M225.867,69.256h-9a.872.872,0,0,1,0-1.744h9a.872.872,0,0,1,0,1.744"/></g></g></svg>';
        case "lodówki":
          return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30.464" height="60" viewBox="0 0 30.464 60"><defs><clipPath id="a"><rect class="a" width="30.464" height="60" transform="translate(-78.532 43.7)"/></clipPath></defs><g transform="translate(78.532 -43.7)"><g class="b"><path class="a" d="M-53.523,78.256a.6.6,0,0,0-.6-.6H-72.48a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.605h18.355a.6.6,0,0,0,.6-.605M-71.706,45.428a5.106,5.106,0,0,0-5.1,5.1V96.871a5.109,5.109,0,0,0,5.1,5.1H-54.9a5.112,5.112,0,0,0,5.1-5.1V50.532a5.109,5.109,0,0,0-5.1-5.1ZM-54.9,103.7H-71.706a6.833,6.833,0,0,1-6.824-6.829V50.532A6.836,6.836,0,0,1-71.706,43.7H-54.9a6.837,6.837,0,0,1,6.829,6.832V96.871A6.835,6.835,0,0,1-54.9,103.7M-70.184,49.172a3.725,3.725,0,0,0-3.725,3.72V94.511a3.728,3.728,0,0,0,3.725,3.724h13.768a3.727,3.727,0,0,0,3.72-3.724V52.892a3.723,3.723,0,0,0-3.72-3.72Zm13.768,50.792H-70.184a5.458,5.458,0,0,1-5.453-5.453V52.892a5.457,5.457,0,0,1,5.453-5.449h13.768a5.456,5.456,0,0,1,5.449,5.449V94.511a5.457,5.457,0,0,1-5.449,5.453"/></g></g></svg>';
        case "kuchnie":
          return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="41.58" height="50" viewBox="0 0 82.6 99.3" style="enable-background:new 0 0 82.6 99.3;" xml:space="preserve"><path d="M76.8,34c0-1-0.8-1.7-1.7-1.7H7.9c-1,0-1.7,0.8-1.7,1.7c0,1,0.8,1.7,1.7,1.7H75C76,35.7,76.8,34.9,76.8,34"/><path d="M24.8,13.8v11.9H57V13.8H24.8z M54.6,23.3H27.2v-7h27.4V23.3z"/><path d="M7.5,42.8v39.5h68V42.8H7.5z M73,79.9H9.9V45.2H73V79.9z"/><path d="M69.4,0H13.5C6.2,0,0.3,5.9,0.3,13.2v73c0,7.3,5.9,13.2,13.2,13.2h55.9c7.3,0,13.2-5.9,13.2-13.2v-73 C82.6,5.9,76.7,0,69.4,0z M79.1,86.1c0,5.4-4.4,9.7-9.7,9.7H13.5c-5.4,0-9.7-4.4-9.7-9.7v-73c0-5.4,4.4-9.7,9.7-9.7h55.9 c5.4,0,9.7,4.4,9.7,9.7V86.1z"/></svg>';
      }
    }
  },
  methods: {
    getIncrementedPointer: function(incrementedBy) {
      let videosLength = this.videos.length;
      if (this.currentPointer + incrementedBy > videosLength - 1) {
        return this.currentPointer + incrementedBy - videosLength;
      } else {
        return this.currentPointer + incrementedBy;
      }
    },
    getDecreasedPointer: function(decreasedBy) {
      let videosLength = this.videos.length;
      if (this.currentPointer - decreasedBy < 0) {
        return videosLength - 1;
      } else {
        return this.currentPointer - decreasedBy;
      }
    },
    youtubeThumbnailUrlByPointer: function(/*pointer*/) {
      let youtubeId = this.videoId(this.currentPointer);
      return "assets/images/video_aggregator/thumbnails/" + youtubeId + ".jpg";
      //return 'https://img.youtube.com/vi/' + this.videos[pointer].youtube_id + '/maxresdefault.jpg'
    },
    goToSlideNo: function(slideNo) {
      this.currentPointer = slideNo;
    },
    videoId: function(pointer) {
      return this.videos[pointer].youtube_id;
    },
    videoTitle: function(pointer) {
      return this.videos[pointer].title;
    },
    videoIcoName: function(pointer) {
      return this.videos[pointer].ico_name;
    },
    videoUrl: function(pointer) {
      return (
        "https://www.youtube.com/watch?v=" + this.videos[pointer].youtube_id
      );
    },
    getThumbnailPath: function(youtube_id) {
      if (process.env.NODE_ENV == "development") {
        return require("@/assets/images/video_aggregator/thumbnails/" +
          youtube_id +
          ".jpg");
      } else {
        return (
          "https://amica.pl/theme/Modern/img/View/video_aggregator/thumbnails/" +
          youtube_id +
          ".jpg"
        );
      }
    },
    getIconPath: function(icon_name) {
      if (process.env.NODE_ENV == "development") {
        return require("@/assets/images/video_aggregator/" +
          icon_name +
          ".svg");
      } else {
        return (
          "https://amica.pl/theme/Modern/img/View/video_aggregator/" +
          icon_name +
          ".svg"
        );
      }
    }
  },
  mounted() {
    console.log(process.env);
  }
};
</script>

<style lang="scss">
.car-container {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 50px;

  @media only screen and (max-width: 768px) {
    margin-bottom: 30px;
  }

  .car-inner {
    width: 91.67vw;
    height: auto;
    padding: 0 20px;

    @media only screen and (max-width: 991px) {
      width: 100vw;
    }

    .car-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      padding-right: calc(100vw / 12 * 1);
      padding-top: 25px;
      padding-bottom: 12px;
      margin-bottom: 46px;
      border-bottom: 1px #d3cec4 solid;

      &::after {
        content: "";
        background-color: #e41429;
        height: 3px;
        width: 74px;
        display: block;
        position: absolute;
        bottom: -2px;
        left: 0;
      }

      @media only screen and (max-width: 768px) {
        padding-right: 0px;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 15px;
      }

      svg {
        width: 52px;
        fill: #e41429;
        margin-left: 10px;
      }

      h2 {
        font-family: "Uni neue";
        color: rgb(63, 63, 63);
        font-weight: 400;
        font-size: 30px;
        text-transform: uppercase;
        margin-left: 0;
        font-weight: 700;
      }

      .car-dots {
        margin-left: auto;

        @media only screen and (max-width: 768px) {
          width: 100%;
          text-align: center;
          margin-top: 10px;

          ul {
            padding-left: 0;
          }
        }

        ul {
          list-style: none;
          margin-bottom: 0;

          li {
            display: inline-block;
            width: 40px;
            height: 8px;
            background: #e8e6e1;
            margin-left: 10px;
            border-radius: 5px;
            cursor: pointer;

            &:hover {
              background: darken(#e8e6e1, 10%);
            }

            &.active {
              background: #27241d;
            }
          }
        }
      }
    }

    .carousel {
      display: flex;
      flex-direction: row;
      font-family: "Lato";
      position: relative;
      margin-bottom: 3em;

      &:hover {
        .carousel-navigation {
          opacity: 1;
        }
      }

      .slide-main {
        width: calc(100vw / 12 * 5);
        position: relative;
        padding: 0 10px;

        @media only screen and (max-width: 1199px) {
          width: calc(100vw / 12 * 7);
        }

        @media only screen and (max-width: 768px) {
          width: calc(100vw / 12 * 12);
          // margin-left: calc(100vw / 12 * 1);
        }

        .inner {
          width: 100%;
          padding-top: 56.4102%;
          position: relative;
          background: green;
          border-radius: 10px;
          background-position: 50% 50% !important;
          background-size: cover !important;
          background-repeat: no-repeat !important;

          -webkit-box-shadow: 0px 20px 33px -16px rgba(0, 0, 0, 0.25);
          -moz-box-shadow: 0px 20px 33px -16px rgba(0, 0, 0, 0.25);
          box-shadow: 0px 20px 33px -16px rgba(0, 0, 0, 0.25);

          &:after {
            content: "";
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;

            -webkit-border-bottom-right-radius: 10px;
            -webkit-border-bottom-left-radius: 10px;
            -moz-border-radius-bottomright: 10px;
            -moz-border-radius-bottomleft: 10px;
            border-bottom-right-radius: 10px;
            border-bottom-left-radius: 10px;

            background: rgb(255, 255, 255);
            background: -moz-linear-gradient(
              180deg,
              rgba(255, 255, 255, 0) 60%,
              rgba(39, 36, 29, 0.8) 100%
            );
            background: -webkit-linear-gradient(
              180deg,
              rgba(255, 255, 255, 0) 60%,
              rgba(39, 36, 29, 0.8) 100%
            );
            background: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0) 60%,
              rgba(39, 36, 29, 0.8) 100%
            );
            filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#27241d",GradientType=1);
          }

          .content {
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
            padding: 40px 50px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: flex-end;
            z-index: 1;

            @media only screen and (max-width: 991px) {
              padding: 20px 25px;
            }

            a {
              background: #e41429;
              border-radius: 10px;
              color: #fff;
              padding: 7px 20px;
              font-size: 18px;
              font-weight: 400;
              margin-bottom: 20px;
              display: flex;
              flex-direction: row;
              align-items: center;

              svg {
                fill: #fff;
                margin-right: 6px;
                height: 18px;
              }

              &:hover {
                text-decoration: none;
                background: darken(#e41429, 5%);
              }
            }

            h3 {
              color: #fff;
            }
          }
        }
      }

      .slide-small {
        width: calc(100vw / 12 * 3);
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 10px;
        padding-right: 10px;
        cursor: pointer;

        &.slide-small--first {
          @media only screen and (max-width: 1199px) {
            width: calc(100vw / 12 * 4);
          }

          @media only screen and (max-width: 991px) {
            width: calc(100vw / 12 * 5);
          }

          @media only screen and (max-width: 768px) {
            display: none;
          }
        }

        &.slide-small--second {
          @media only screen and (max-width: 1199px) {
            display: none;
          }
        }

        .video {
          width: 100%;
          border-radius: 10px;
          background: red;
          padding-top: 56.4102%;
          margin-bottom: 25px;
          background-position: 50% 50% !important;
          background-size: cover !important;
          background-repeat: no-repeat !important;
          position: relative;

          @media only screen and (max-width: 1440px) {
            margin-bottom: 15px;
          }

          .content {
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 100%;
            padding: 10px 25px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-end;
            z-index: 1;

            @media only screen and (max-width: 991px) {
              padding: 0px 10px;
            }

            a {
              background: #e41429;
              border-radius: 10px;
              color: #fff;
              padding: 7px 20px;
              font-size: 18px;
              font-weight: 400;
              margin-bottom: 20px;
              display: flex;
              flex-direction: row;
              align-items: center;

              svg {
                fill: #fff;
                margin-right: 6px;
                height: 18px;
              }

              &:hover {
                text-decoration: none;
                background: darken(#e41429, 5%);
              }
            }

            .function-ico {
              width: 85px;
              height: 85px;
              position: absolute;
              top: -42.5px;
              left: 25px;
            }
          }
        }

        h3 {
          font-family: "Lato";
          font-size: 26px;
          line-height: 36px;
          font-weight: 400;
          max-width: 80%;
          padding: 0 15px;
          height: calc(36px * 3);
          overflow: hidden;

          @media only screen and (max-width: 1440px) {
            font-size: 22px;
            line-height: 28px;
            height: calc(28px * 3);
          }

          span {
            color: #e41429;
          }
        }
      }

      .carousel-navigation {
        position: absolute;
        top: 0px;
        height: 100%;
        width: calc(100vw / 12 * 1);
        background: red;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2;
        opacity: 0;
        cursor: pointer;

        &.nav--left {
          left: 10px;

          background: rgb(255, 255, 255);
          background: -moz-linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.6825105042016807) 0%,
            rgba(255, 255, 255, 0) 50%
          );
          background: -webkit-linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.6825105042016807) 0%,
            rgba(255, 255, 255, 0) 50%
          );
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0.6825105042016807) 0%,
            rgba(255, 255, 255, 0) 50%
          );
        }

        &.nav--right {
          right: 0px;

          background: rgb(255, 255, 255);
          background: -moz-linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.6825105042016807) 50%
          );
          background: -webkit-linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.6825105042016807) 50%
          );
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.6825105042016807) 50%
          );
        }

        -webkit-transition: all 0.2s ease-in-out;
        -moz-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;

        .arrow-right {
          width: 40px;
          height: 40px;
          position: relative;
          margin-left: auto;
          margin-right: 30px;
          cursor: pointer;

          @media only screen and (max-width: 991px) {
            margin-right: 0px;
          }

          &:after {
            content: "";
            position: absolute;
            top: 0px;
            left: 0px;
            width: 32px;
            height: 9px;
            background: #000;
            border-radius: 9px;
            transform: rotate(45deg);

            @media only screen and (max-width: 991px) {
              width: 18px;
              height: 7px;
            }
          }

          &:before {
            content: "";
            position: absolute;
            top: 16px;
            left: 0px;
            width: 32px;
            height: 9px;
            background: #000;
            border-radius: 9px;
            transform: rotate(-45deg);

            @media only screen and (max-width: 991px) {
              width: 18px;
              height: 7px;
              top: 9px;
            }
          }
        }

        .arrow-left {
          width: 40px;
          height: 40px;
          position: relative;
          margin-right: auto;
          margin-left: 30px;
          cursor: pointer;

          @media only screen and (max-width: 991px) {
            margin-left: 10px;
          }

          &:after {
            content: "";
            position: absolute;
            top: 0px;
            left: 0px;
            width: 32px;
            height: 9px;
            background: #000;
            border-radius: 9px;
            transform: rotate(-45deg);

            @media only screen and (max-width: 991px) {
              width: 18px;
              height: 7px;
            }
          }

          &:before {
            content: "";
            position: absolute;
            top: 16px;
            left: 0px;
            width: 32px;
            height: 9px;
            background: #000;
            border-radius: 9px;
            transform: rotate(45deg);

            @media only screen and (max-width: 991px) {
              width: 18px;
              height: 7px;
              top: 9px;
            }
          }
        }
      }
    }
  }
}

.car-section-header {
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  h2 {
    margin-left: 20px;
    margin-bottom: 0;
    text-transform: capitalize;
    font-size: 48px;
    font-family: "Uni neue";
  }
}

.catIcoBox {
  background: linear-gradient(#e41429, #ab091e);
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 10px;

  svg {
    fill: #fff !important;
    margin: 0 !important;
    width: 100% !important;
    height: 100% !important;
  }
}

//arts

.gr-articles {
  display: flex;
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
  }
}

.gr-article {
  display: flex;
  flex-direction: column;
  align-items: start;
  text-decoration: none;
  color: #857f72;
  padding-left: 12px;
  padding-right: 12px;
  max-width: 460px;

  img {
    margin: 0 -12px;
    width: 100%;
    max-height: 260px;
    height: calc((100vw * 260px) / 1920);
    object-fit: cover;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    margin-bottom: 16px;
  }

  h4 {
    color: #857f72;
    display: inline-block;
    padding-bottom: 5px;
    border-bottom: 1px #857f72 solid;
    text-transform: capitalize;
    font-size: 14px;
  }
  h3 {
    font-size: 26px;
    font-family: "Uni Neue";
    font-weight: 700;
  }
  p {
    font-size: 18px;
  }

  &:hover {
    text-decoration: none;

    h3 {
      color: #e41429;
    }
    h4 {
      color: #27241d;
      border-color: #27241d;
    }
    p {
      color: #27241d;
    }
  }
}

.slide-fade-enter-active {
  // transition: all .1s ease;
  transition: all 0.05s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-leave-active {
  transition: all 0.05s cubic-bezier(1, 0.5, 0.8, 1);
  // transition: all .1s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
}
</style>
